(function () {
  'use strict';

  if (window.__rgJulyGiveawayInitialized) return;
  window.__rgJulyGiveawayInitialized = true;

  var ENTRY_STORAGE_KEY = 'rgJulyGiveawayEntry2026';
  var POPUP_CLOSED_KEY = 'rgJulyGiveawayPopupClosed2026';
  var POPUP_SESSION_KEY = 'rgJulyGiveawayPopupSeen2026';

  function safeJsonParse(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function getStoredEntry() {
    try {
      return safeJsonParse(localStorage.getItem(ENTRY_STORAGE_KEY));
    } catch (error) {
      return null;
    }
  }

  function setStoredEntry(entry) {
    try {
      localStorage.setItem(ENTRY_STORAGE_KEY, JSON.stringify(entry));
    } catch (error) {}
  }

  function deadlinePassed(root) {
    var deadline = root.getAttribute('data-deadline');
    return deadline ? Date.now() >= new Date(deadline).getTime() : false;
  }

  function setStatus(form, message, state) {
    var status = form.querySelector('[data-rg-status]');
    if (!status) return;
    status.textContent = message || '';
    status.setAttribute('data-state', state || '');
  }

  function setBusy(button, busy, busyLabel) {
    if (!button) return;
    if (busy) {
      button.dataset.originalLabel = button.textContent;
      button.textContent = busyLabel || 'Saving…';
      button.disabled = true;
    } else {
      button.textContent = button.dataset.originalLabel || button.textContent;
      button.disabled = false;
    }
  }

  function profileProperties(source, shared, platform, entry) {
    var properties = {
      'RGM Giveaway Campaign': 'July 2026',
      'RGM July Giveaway Entered': true,
      'RGM July Giveaway Base Entries': 1,
      'RGM July Giveaway Entry Source': source,
      'RGM July Giveaway Eligible US 18+': true,
      'RGM July Giveaway Entry Date': entry.entryDate || new Date().toISOString()
    };

    if (shared) {
      properties['RGM July Giveaway Shared'] = true;
      properties['RGM July Giveaway Share Entries'] = 5;
      properties['RGM July Giveaway Share Platform'] = platform;
      properties['RGM July Giveaway Share Date'] = new Date().toISOString();
    }

    return properties;
  }

  async function subscribe(root, entry, shared, platform) {
    var listId = root.getAttribute('data-klaviyo-list-id');
    var source = root.getAttribute('data-entry-source') || 'Giveaway page';
    var properties = profileProperties(source, shared, platform, entry);
    var fields = Object.keys(properties);
    var body = new URLSearchParams({
      g: listId,
      email: entry.email,
      '$first_name': entry.firstName,
      '$last_name': entry.lastName,
      '$source': 'Royal Gems July Monthly Giveaway - ' + source,
      '$fields': fields.join(',')
    });

    fields.forEach(function (field) {
      body.set(field, String(properties[field]));
    });

    var response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      },
      body: body.toString()
    });

    var result = await response.json();
    if (!response.ok || !result.success) {
      throw new Error('Entry service returned ' + response.status);
    }
  }

  function revealShare(form, entry) {
    var panel = form.querySelector('[data-rg-share-panel]');
    if (!panel) return;
    panel.hidden = false;
    panel.dataset.entryEmail = entry.email;
    panel.dataset.entryFirstName = entry.firstName;
    panel.dataset.entryLastName = entry.lastName;
    panel.dataset.entryDate = entry.entryDate || '';
    var heading = panel.querySelector('h3');
    if (heading) heading.setAttribute('tabindex', '-1');
    if (heading) heading.focus({ preventScroll: true });
  }

  function getEntryFromSharePanel(panel) {
    return {
      email: panel.dataset.entryEmail || '',
      firstName: panel.dataset.entryFirstName || '',
      lastName: panel.dataset.entryLastName || '',
      entryDate: panel.dataset.entryDate || ''
    };
  }

  function shareUrl(root) {
    return root.getAttribute('data-giveaway-url') || window.location.href.split('#')[0];
  }

  function shareText() {
    return 'Enter the Royal Gems July Monthly Giveaway for a chance to win a $499.99 clear quartz sphere!';
  }

  function hideSharePanels() {
    document.querySelectorAll('[data-rg-share-panel]').forEach(function (sharePanel) {
      sharePanel.hidden = true;
    });
  }

  function initializeShareThanks(form) {
    var overlay = form.querySelector('[data-rg-share-thanks]');
    if (!overlay || overlay.dataset.rgInitialized === 'true') return;
    overlay.dataset.rgInitialized = 'true';
    var dialog = overlay.querySelector('[role="dialog"]');
    var previousFocus = null;

    function focusable() {
      return Array.prototype.slice.call(
        overlay.querySelectorAll('button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return element.offsetParent !== null;
      });
    }

    function close() {
      overlay.hidden = true;
      document.body.classList.remove('rg-giveaway-share-thanks-open');
      if (
        previousFocus &&
        previousFocus.focus &&
        previousFocus.isConnected &&
        previousFocus.offsetParent !== null
      ) {
        previousFocus.focus();
      } else {
        var status = form.querySelector('[data-rg-status]');
        if (status) {
          status.setAttribute('tabindex', '-1');
          status.focus();
        }
      }
    }

    overlay._rgShowShareThanks = function () {
      previousFocus = document.activeElement;
      overlay.hidden = false;
      document.body.classList.add('rg-giveaway-share-thanks-open');
      window.setTimeout(function () {
        if (dialog) dialog.focus();
      }, 40);
    };

    overlay.querySelectorAll('[data-rg-share-thanks-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) close();
    });
    overlay.addEventListener('keydown', function (event) {
      if (overlay.hidden) return;
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      var elements = focusable();
      if (!elements.length) return;
      var first = elements[0];
      var last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function showShareThanks(form) {
    var overlay = form.querySelector('[data-rg-share-thanks]');
    if (overlay && overlay._rgShowShareThanks) overlay._rgShowShareThanks();
  }

  async function recordShare(root, form, panel, platform, button) {
    var entry = getEntryFromSharePanel(panel);
    if (!entry.email) {
      setStatus(form, 'Please enter first so we can attach the bonus entries to your name.', 'error');
      return;
    }

    var previousEntry = getStoredEntry();
    if (previousEntry && previousEntry.shared) {
      hideSharePanels();
      setStatus(form, 'Your entry and 5 share entries are already saved.', 'success');
      return;
    }

    setBusy(button, true, 'Adding 5 entries…');
    try {
      await subscribe(root, entry, true, platform);
      var stored = getStoredEntry() || entry;
      stored.shared = true;
      stored.sharePlatform = platform;
      setStoredEntry(stored);
      setBusy(button, false);
      hideSharePanels();
      setStatus(form, 'Your entry and 5 share entries are saved.', 'success');
      showShareThanks(form);
    } catch (error) {
      setStatus(form, 'Your main entry is saved, but the share entries did not save yet. Please try again.', 'error');
      setBusy(button, false);
      return;
    }
  }

  function initializeForm(root, form) {
    if (form.dataset.rgInitialized === 'true') return;
    form.dataset.rgInitialized = 'true';
    initializeShareThanks(form);

    var closedMessage = form.querySelector('[data-rg-closed]');
    var formFields = form.querySelector('[data-rg-form-fields]');
    var storedEntry = getStoredEntry();

    if (deadlinePassed(root)) {
      if (formFields) formFields.hidden = true;
      if (closedMessage) closedMessage.hidden = false;
      return;
    }

    if (storedEntry && storedEntry.email) {
      if (storedEntry.shared) {
        setStatus(form, 'Your entry and 5 share entries are already saved.', 'success');
        hideSharePanels();
      } else {
        revealShare(form, storedEntry);
      }
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      if (deadlinePassed(root)) {
        if (formFields) formFields.hidden = true;
        if (closedMessage) closedMessage.hidden = false;
        return;
      }

      var honeypot = form.querySelector('[data-rg-honeypot]');
      if (honeypot && honeypot.value) return;

      if (!form.reportValidity()) return;

      var entry = {
        firstName: form.querySelector('[name="contact[first_name]"]').value.trim().slice(0, 80),
        lastName: form.querySelector('[name="contact[last_name]"]').value.trim().slice(0, 80),
        email: form.querySelector('[name="contact[email]"]').value.trim().toLowerCase().slice(0, 200),
        entryDate: new Date().toISOString(),
        shared: false
      };
      var submitButton = form.querySelector('[type="submit"]');

      setBusy(submitButton, true, 'Saving your entry…');
      setStatus(form, '', '');

      try {
        await subscribe(root, entry, false, '');
        setStoredEntry(entry);
        revealShare(form, entry);
        setStatus(form, 'You’re entered! Your name has 1 entry. Share next for 5 more.', 'success');
      } catch (error) {
        setStatus(form, 'We couldn’t save your entry. Please check your connection and try again.', 'error');
      } finally {
        setBusy(submitButton, false);
      }
    });

    form.querySelectorAll('[data-rg-share]').forEach(function (button) {
      button.addEventListener('click', async function () {
        var panel = button.closest('[data-rg-share-panel]');
        var platform = button.getAttribute('data-rg-share');
        var url = shareUrl(root);

        if (platform === 'facebook') {
          var facebookWindow = window.open(
            'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
            'rgGiveawayShare',
            'width=720,height=560'
          );
          if (!facebookWindow) {
            setStatus(form, 'Please allow the Facebook share window, then try again.', 'error');
            return;
          }
          try {
            facebookWindow.opener = null;
          } catch (error) {}
          await recordShare(root, form, panel, 'Facebook', button);
          return;
        }

        try {
          var recordedPlatform = 'Instagram / copied link';
          if (navigator.share) {
            await navigator.share({ title: 'Royal Gems July Monthly Giveaway', text: shareText(), url: url });
            recordedPlatform = 'Instagram / device share';
          } else if (navigator.clipboard) {
            await navigator.clipboard.writeText(shareText() + ' ' + url);
            window.open('https://www.instagram.com/', 'rgGiveawayInstagram', 'noopener,noreferrer');
          } else {
            window.prompt('Copy this giveaway link for Instagram:', url);
            window.open('https://www.instagram.com/', 'rgGiveawayInstagram', 'noopener,noreferrer');
          }
          await recordShare(root, form, panel, recordedPlatform, button);
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          setStatus(form, 'Copy the giveaway link, then click the Instagram share button again.', 'error');
        }
      });
    });
  }

  function initializeRoot(root) {
    root.querySelectorAll('[data-rg-entry-form]').forEach(function (form) {
      initializeForm(root, form);
    });

    var countdown = root.querySelector('[data-rg-countdown]');
    if (!countdown) return;
    var deadline = new Date(root.getAttribute('data-deadline')).getTime();
    if (!Number.isFinite(deadline)) return;

    countdown.textContent = '';
    countdown.setAttribute('role', 'timer');
    countdown.setAttribute('aria-live', 'off');
    countdown.setAttribute('aria-atomic', 'true');

    var countdownLabel = document.createElement('span');
    countdownLabel.className = 'rg-countdown__label';
    countdownLabel.textContent = 'Entries close in';
    countdownLabel.setAttribute('aria-hidden', 'true');
    countdown.appendChild(countdownLabel);

    var units = document.createElement('span');
    units.className = 'rg-countdown__units';
    units.setAttribute('aria-hidden', 'true');
    countdown.appendChild(units);

    var unitValues = {};
    [
      ['days', 'Days'],
      ['hours', 'Hours'],
      ['minutes', 'Minutes'],
      ['seconds', 'Seconds']
    ].forEach(function (definition) {
      var unit = document.createElement('span');
      unit.className = 'rg-countdown__unit';
      unit.dataset.rgCountdownUnit = definition[0];

      var value = document.createElement('strong');
      value.className = 'rg-countdown__value';
      value.dataset.rgCountdownValue = definition[0];
      value.textContent = '--';

      var label = document.createElement('small');
      label.textContent = definition[1];

      unit.appendChild(value);
      unit.appendChild(label);
      units.appendChild(unit);
      unitValues[definition[0]] = value;
    });

    function updateUnit(name, value) {
      var nextValue = String(value).padStart(2, '0');
      var element = unitValues[name];
      if (!element || element.textContent === nextValue) return;
      element.textContent = nextValue;
      element.classList.remove('is-ticking');
      void element.offsetWidth;
      element.classList.add('is-ticking');
    }

    var tickerId = null;

    function updateCountdown() {
      var remaining = Math.max(0, deadline - Date.now());
      if (remaining <= 0) {
        countdown.textContent = 'Entries are closed';
        countdown.classList.add('rg-giveaway__deadline-pill--closed');
        countdown.removeAttribute('aria-label');
        if (tickerId) window.clearInterval(tickerId);
        return;
      }
      var days = Math.floor(remaining / 86400000);
      var hours = Math.floor((remaining % 86400000) / 3600000);
      var minutes = Math.floor((remaining % 3600000) / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);

      updateUnit('days', days);
      updateUnit('hours', hours);
      updateUnit('minutes', minutes);
      updateUnit('seconds', seconds);
      countdown.setAttribute(
        'aria-label',
        days + ' days, ' + hours + ' hours, ' + minutes + ' minutes, and ' + seconds + ' seconds left to enter'
      );
    }

    updateCountdown();
    if (Date.now() < deadline) tickerId = window.setInterval(updateCountdown, 1000);
  }

  function initializePopup(popup) {
    if (!popup || deadlinePassed(popup)) return;

    var dialog = popup.querySelector('[role="dialog"]');
    var closeButton = popup.querySelector('[data-rg-popup-close]');
    var previousFocus = null;
    var hasShown = false;
    var loadedAt = Date.now();
    var closedAt = 0;

    try {
      closedAt = parseInt(localStorage.getItem(POPUP_CLOSED_KEY) || '0', 10);
      if (sessionStorage.getItem(POPUP_SESSION_KEY) === '1') return;
    } catch (error) {}
    if (closedAt && Date.now() - closedAt < 24 * 60 * 60 * 1000) return;

    function focusable() {
      return Array.prototype.slice.call(
        popup.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return element.offsetParent !== null;
      });
    }

    function show() {
      if (hasShown || !popup.hidden || deadlinePassed(popup)) return;
      hasShown = true;
      previousFocus = document.activeElement;
      popup.hidden = false;
      document.body.classList.add('rg-giveaway-popup-open');
      try {
        sessionStorage.setItem(POPUP_SESSION_KEY, '1');
      } catch (error) {}
      window.setTimeout(function () {
        if (closeButton) closeButton.focus();
      }, 60);
    }

    function close() {
      popup.hidden = true;
      document.body.classList.remove('rg-giveaway-popup-open');
      try {
        localStorage.setItem(POPUP_CLOSED_KEY, String(Date.now()));
      } catch (error) {}
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    }

    if (closeButton) closeButton.addEventListener('click', close);
    popup.addEventListener('click', function (event) {
      if (event.target === popup) close();
    });
    document.addEventListener('keydown', function (event) {
      if (popup.hidden) return;
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      var elements = focusable();
      if (!elements.length) return;
      var first = elements[0];
      var last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener(
      'scroll',
      function () {
        if (Date.now() - loadedAt >= 12000 && window.scrollY >= 420) show();
      },
      { passive: true }
    );
    document.addEventListener('mousemove', function (event) {
      if (Date.now() - loadedAt >= 12000 && event.clientY <= 12 && window.innerWidth > 768) show();
    });
    window.setTimeout(show, 26000);
  }

  document.querySelectorAll('[data-rg-giveaway-root]').forEach(initializeRoot);
  initializePopup(document.querySelector('[data-rg-giveaway-popup]'));
})();
